import React, { useState } from 'react';
import ServiceDropdown from './ServiceDropdown';
import './Forms.css';
import axios from 'axios';


const initialFormData = {
  zipcode: '',
  name: '',
  email: '',
  phone: '',
  contactPreference: '',
  service: [],
};


const RAQForm = ({ onToggleRAQ }) => {
  const [formData, setFormData] = useState(initialFormData);
  const [isLoading, setIsLoading] = useState(false);
  const [submissionMessage, setSubmissionMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const handleServiceChange = (service) => {
    setFormData(prevState => ({
      ...prevState,
      service: prevState.service.includes(service)
        ? prevState.service.filter(s => s !== service)
        : [...prevState.service, service]
    }));
  };
  
  const config = {
    headers: {
        'Content-Type': 'application/json',
    },
  };

  const payload = {
    body: JSON.stringify(formData)
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Start loading
    setSubmissionMessage(''); // Reset submission message

    try {
        const response = await axios.post('https://g032cq2vc8.execute-api.us-east-1.amazonaws.com/default/cecEmailHandler', payload, config);
        setSubmissionMessage('We have received your request and will reach out to you shortly. Thank you'); // Set success message
        setFormData(initialFormData); // Reset form data on success
    } catch (error) {
        console.error('Error: Code - 400', );
        setSubmissionMessage('Failed to submit request, please try again.'); // Set failure message
    } finally {
        setIsLoading(false); // Stop loading regardless of outcome
    }
  };



  // You would add your reCAPTCHA integration here

  return (
    <div className='raq-form'>
      <div className='raq-header'>
        <h3>Request a quote</h3>
        <button onClick={onToggleRAQ} style={{ cursor: 'pointer' }}>X</button>
      </div>
      <form onSubmit={handleSubmit} className="quote-form">
        <div className="form-group">
          <label htmlFor="zipcode">Zipcode<span className='aes'>*</span></label>
          <input type="text" id="zipcode" name="zipcode" value={formData.zipcode} placeholder='Zipcode' required onChange={handleChange} className="form-control" />
        </div>
        <div className="form-group">
          <label htmlFor="name">Name or Company name<span className='aes'>*</span></label>
          <input type="text" id="name" name="name" value={formData.name} placeholder='Name or Company name' required onChange={handleChange} className="form-control" />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email<span className='aes'>*</span></label>
          <input type="email" id="email" name="email" value={formData.email} placeholder='Email' required onChange={handleChange} className="form-control" />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Phone Number<span className='aes'>*</span></label>
          <input type="tel" id="phone" name="phone" value={formData.value} placeholder='+1 (888) 888-8888' required onChange={handleChange} className="form-control" />
        </div>
        <div className="form-group">
            <label htmlFor="contactPreference">Preferred Form of Contact<span className='aes'>*</span></label>
            <div className="custom-select-wrapper">
              <select id="contactPreference" name="contactPreference" required onChange={handleChange} className="custom-select form-control">
                <option value="">Select an option</option>
                <option value="email">Email</option>
                <option value="phone">Phone</option>
              </select>
            </div>
        </div>
        <div className="form-group">
          <label>Select Service(s)<span className='aes'>*</span></label>
          <div className="service-dropdown-wrapper">
            <ServiceDropdown 
              selectedServices={formData.service}
              onServiceChange={handleServiceChange}
            />
          </div>
        </div>
        {/* Implement your reCAPTCHA component here */}
        <div className="form-group">
          <button
            type="submit"
            className={`submit-btn ${isLoading ? 'disabled' : ''}`}
            disabled={isLoading}
          >
            {isLoading ? 'Sending...' : 'Submit Request'}
          </button>

          {isLoading && <div className="loading-indicator"></div>}
        </div>

        {submissionMessage && <div className="submission-message">{submissionMessage}</div>}
      </form>
    </div>
  );
};

export default RAQForm;